/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class GcpDiskRestoreData {
  /**
  * The id of the disk to restore
  */
  'diskId': string;
  /**
  * The name of the restored disk
  */
  'diskName': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "diskId",
      "baseName": "diskId",
      "type": "string",
      "format": ""
    },
    {
      "name": "diskName",
      "baseName": "diskName",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return GcpDiskRestoreData.attributeTypeMap;
  }

  public constructor() {
  }
}

